export default __webpack_public_path__ + "static/media/onboarding-dk.e7481cc7.mp4";